import {
    Button,
    ButtonGroup,
    DialogTitle,
    DialogContent,
    Grid, Select, MenuItem, FormControlLabel, Radio,
    TextField,
    DialogActions,
    InputAdornment,
    Typography,
} from "@material-ui/core";
import { useAlert } from "react-alert";
import { KeyboardDatePicker, KeyboardTimePicker } from "@material-ui/pickers";
import { useState } from 'react';

const formatDates = (data) => {
    if (data == null)
        return data;
    data = JSON.parse(JSON.stringify(data))
    // push the time forward? by UsersTimeZoneValue for displaying
    if (data.startTime != null) {
        const tempDate = new Date(data.startTime)
        // data.startTime = new Date(tempDate.getTime() + tempDate.getTimezoneOffset() * 60000)
        data.startTime = new Date(tempDate.getTime())
        data.startTime = new Date(data.startTime.setMinutes(data.startTime.getMinutes() + data.startTime.getTimezoneOffset()))
        console.log(tempDate, data.startTime)
    }
    if (data.endTime != null) {
        const tempDate = new Date(data.endTime)
        // data.endTime = new Date(tempDate.getTime() + tempDate.getTimezoneOffset() * 60000)
        data.endTime = new Date(tempDate.getTime())
        data.endTime = new Date(data.endTime.setMinutes(data.endTime.getMinutes() + data.endTime.getTimezoneOffset()))
    }

    console.log("Formatted", data);
    return data;
}

const normalizeDate = (date) => {
    if (date == null)
        return date;
    let temp_date = new Date(date.getTime())
    temp_date = new Date(temp_date.setMinutes(temp_date.getMinutes() - temp_date.getTimezoneOffset()))
    // return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    return temp_date
}


const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
export default function AddSlotComponent({ data, onUpdate, onClose }) {
    const alert = useAlert();
    const [slot, setSlot] = useState(formatDates(data) || {
        start: new Date(),
        startTime: new Date(),
        endTime: new Date(),
        end: new Date(),
        repeatOn: [],
        endingType: 'ends-never',
        repeatEvery: 1,
        repeatFrequency: "week",
        info: '',
    });


    const toggleDay = (day) => {
        const updated = [...slot.repeatOn];
        const index = updated.indexOf(day);
        if (index > -1) {
            updated.splice(index, 1);
        } else {
            updated.push(day);
        }
        setSlot({ ...slot, repeatOn: updated })
    }

    const onAdd = () => {
        // validate
        if (slot.start === null) {
            return;
        }
        if (slot.repeatFrequency === 'week' && slot.repeatOn.length === 0) {
            alert.show("Please select the days it should recur weekly")
            return;
        }
        if (slot.end === null) {
            return;
        }

        onUpdate({
            ...slot,
            startTime: normalizeDate(slot.startTime),
            endTime: normalizeDate(slot.endTime),

        });
    }

    const isDayActive = (day) => {
        return slot.repeatOn?.includes(day);
    }
    const WeekToggleButtons = () => {
        const buttons = DAYS.map(day => {
            return (
                <Button onClick={() => toggleDay(day)}
                    color={isDayActive(day) ? 'primary' : ''}
                    key={day}
                    variant="contained"
                    disableElevation
                >
                    {day[0]}
                </Button>
            );
        });
        return (<ButtonGroup size="small">{buttons}</ButtonGroup>);
    }

    return (
        <>
            <DialogTitle id="form-dialog-title">Add Slot</DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item xs={12} style={{ marginBottom: '16px' }}>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <KeyboardTimePicker
                                    label="Start time"
                                    value={slot.startTime} onChange={(startTime) => setSlot((slot) => ({ ...slot, startTime }))}
                                    inputVariant="outlined"
                                    fullWidth
                                />

                            </Grid>
                            <Grid item xs={6}>
                                <KeyboardTimePicker
                                    label="End time"
                                    value={slot.endTime} onChange={(endTime) => setSlot((slot) => ({ ...slot, endTime }))}
                                    inputVariant="outlined"
                                    fullWidth
                                />

                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1} style={{ marginBottom: '16px' }} justify="center" alignItems="center">
                        <Grid item xs={4} style={{ flex: '1' }}>
                            <Typography >
                                Repeat every
                            </Typography>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField size="small" type="number" fullWidth variant="outlined"
                                value={slot.repeatEvery} onChange={(e) => setSlot((slot) => ({ ...slot, repeatEvery: e.target.value }))}
                                inputProps={{
                                    type: "number",
                                    min: "1"
                                }} />
                        </Grid>
                        <Grid item xs={4}>
                            <Select margin="dense" value={slot.repeatFrequency}
                                onChange={(e) => setSlot((slot) => ({ ...slot, repeatFrequency: e.target.value }))}
                                variant="outlined" fullWidth>
                                {
                                    ["day", "week", "month", "year"].map((option, i) => (
                                        <MenuItem value={option} key={i}>{option}</MenuItem>
                                    ))
                                }
                            </Select>
                        </Grid>
                    </Grid>
                    {['week', 'month'].includes(slot.repeatFrequency) && <Grid item xs={12} style={{ marginBottom: '16px' }}>
                        <Grid container>
                            <Grid item style={{ flex: '1' }}><Typography>Repeats on</Typography></Grid>
                            {slot.repeatFrequency === 'week' && <Grid item>
                                {WeekToggleButtons()}
                            </Grid>}
                            {slot.repeatFrequency === 'month' && <Grid item> 
                                
                                <Typography>Monthly on day {typeof slot?.start=== 'string'? slot?.start.slice(8,10):slot?.start.getDate()} </Typography>
                            </Grid>}
                        </Grid>
                    </Grid>}
                    <Grid item xs={12} style={{ marginBottom: '16px', marginTop: 8 }}>
                        <KeyboardDatePicker
                            label="Start date"
                            value={slot.start} onChange={(start) => setSlot((slot) => ({ ...slot, start }))}
                            inputVariant="outlined"
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="subtitle1">
                            Ends
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel value="end" control={
                            <Radio color="primary" checked={slot.endingType === 'ends-never'} onChange={() => setSlot((slot) => ({ ...slot, endingType: 'ends-never' }))} />
                        } label="Never" />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container justify="center" alignItems="center">
                            <Grid item xs={6}>
                                <FormControlLabel value="end" control={
                                    <Radio color="primary" checked={slot.endingType === 'ends-on'} onChange={() => setSlot((slot) => ({ ...slot, endingType: 'ends-on' }))} />
                                } label="On" />
                            </Grid>
                            <Grid item xs={6}>
                                <KeyboardDatePicker
                                    inputVariant="outlined"
                                    variant="dialog"
                                    format="dd/MM/yyyy"
                                    disabled={slot.endingType !== 'ends-on'}
                                    style={{ marginRight: '8px' }}
                                    margin="dense"
                                    value={slot.endsOn}
                                    onChange={(endsOn) => setSlot((slot) => ({ ...slot, endsOn }))}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container justify="center" alignItems="center">
                            <Grid item xs={6}>
                                <FormControlLabel value="end" control={
                                    <Radio color="primary" checked={slot.endingType === 'ends-after'} onChange={() => setSlot((slot) => ({ ...slot, endingType: 'ends-after' }))} />
                                } label="After" />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    margin="dense"
                                    inputProps={{
                                        type: "number",
                                        min: "0"
                                    }}
                                    disabled={slot.endingType !== 'ends-after'}
                                    value={slot.endsAfter || 0}
                                    onChange={(e) => setSlot((slot) => ({ ...slot, endsAfter: e.target.value }))}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">occurrences</InputAdornment>
                                    }}
                                    type="number" fullWidth variant="outlined" />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        style={{ marginTop: 8 }}
                        label="Info"
                        multiline
                        rows={4}
                        onCh
                        variant="outlined"
                        value={slot.info}
                        onChange={(e) => setSlot((slot) => ({ ...slot, info: e.target.value }))}
                        fullWidth
                    />
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">Cancel</Button>
                <Button onClick={onAdd} color="primary">ADD</Button>
            </DialogActions>
        </>
    )
}
